"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cli_1 = require("./cli");
const param_types_1 = require("./param-types");
const cmd_builder_1 = require("./cmd-builder");
function createCliWithDefaultArgs() {
    return new cli_1.Cli().addGlobalNamedArgs({
        help: cmd_builder_1.namedArg(param_types_1.types.booleanFlag, {
            shortName: "h",
            description: "Shows help.",
            excludeFromSchema: true,
        }),
        version: cmd_builder_1.namedArg(param_types_1.types.booleanFlag, {
            shortName: "v",
            description: "Shows the version.",
            excludeFromSchema: true,
        }),
        "cmd::gui": cmd_builder_1.namedArg(param_types_1.types.booleanFlag, {
            description: "Shows a gui.",
            excludeFromSchema: true,
        }),
        "cmd::schema": cmd_builder_1.namedArg(param_types_1.types.booleanFlag, {
            description: "Shows the schema.",
            excludeFromSchema: true,
        }),
        "cmd::json-args": cmd_builder_1.namedArg(param_types_1.types.string.withDefaultValue(undefined), {
            description: "Reads json input.",
            excludeFromSchema: true,
        }),
    });
}
exports.createCliWithDefaultArgs = createCliWithDefaultArgs;
//# sourceMappingURL=cli-with-default-args.js.map